import {TinyColor} from '@ctrl/tinycolor';
import type { BdColorFactoryType} from './color-factory';
import {BdColorFactory} from './color-factory';

export interface BdColorScheme {
  low: TinyColor;
  high: TinyColor;
}

export const BD_COLOR_SCHEME_ASC: BdColorScheme = {
  low: new TinyColor('hsl(0, 100%, 50%)'),
  high: new TinyColor('hsl(180, 100%, 50%)')
};

export class BdColorSchemeFactory extends BdColorFactory {

  public static fromObject(obj: BdColorSchemeFactoryOptions): BdColorSchemeFactory {
    let colorScheme: BdColorScheme;

    if (obj.colorScheme) {
      colorScheme = {
        low: obj.colorScheme.low ? new TinyColor(obj.colorScheme.low) : BD_COLOR_SCHEME_ASC.low,
        high: obj.colorScheme.high ? new TinyColor(obj.colorScheme.high) : BD_COLOR_SCHEME_ASC.high
      };
    }

    return new BdColorSchemeFactory(colorScheme);
  }

  type: BdColorFactoryType = 'scheme';

  constructor(
      public colorScheme: BdColorScheme = BD_COLOR_SCHEME_ASC
  ) {
    super();
  }

  override clone(): BdColorSchemeFactory {
    return new BdColorSchemeFactory({
      low: this.colorScheme.low.clone(),
      high: this.colorScheme.high.clone()
    });
  }

  public toJSON(): BdColorSchemeFactoryOptions {
    return {
      type: this.type,
      colorScheme: {
        low: this.colorScheme.low.toHslString(),
        high: this.colorScheme.high.toHslString()
      }
    };
  }

  equals(other: BdColorFactory): boolean {
    switch (other.type) {
      case 'scheme': {
        return this.colorScheme.high.equals((other as BdColorSchemeFactory).colorScheme.high) &&
          this.colorScheme.low.equals((other as BdColorSchemeFactory).colorScheme.low);
      }
      default: {
        return false;
      }
    }
  }

  getColorForValue(value: number, minValue: number, maxValue: number): TinyColor {
    let targetColor: TinyColor;

    if (value === minValue) {
      targetColor = this.colorScheme.low;
    } else if (value === maxValue) {
      targetColor = this.colorScheme.high;
    } else {
      const amount = Math.round(this.percentage(value, minValue, maxValue) * 100);

      targetColor = this.colorScheme.low
          .clone()
          .mix(
              this.colorScheme.high.clone(),
              amount
          );
    }

    return targetColor;
  }
}

export interface BdColorSchemeFactoryOptions {
  type: BdColorFactoryType,
  colorScheme: {
    low: string,
    high: string
  }
}
